import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

import {
  deletePlant,
  onToggleDeleteModal
} from './actions';

import { useAuth0 } from "../../react-auth0-spa";

import './styles.scss';

const DeleteFromModal = ({
  deletePlant,
  modal,
  onToggleDeleteModal,
  plantId,
}) => {
  const { user } = useAuth0();
  const onDeletePlant = async () => {
    const userId = user.sub.split('|')[1];
    deletePlant(userId, plantId);
    onToggleDeleteModal(!modal);
  }

  return (
    <>
      <Modal
        centered={true}
        className="delete-plant-modal"
        isOpen={modal}
        toggle={onToggleDeleteModal.bind(this, !modal)}
      >
        <ModalBody>
          Are you sure you want to delete this plant?
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={onDeletePlant}>Yes</Button>
          <Button color="danger" onClick={onToggleDeleteModal.bind(this, !modal)}>No</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const mapStateToProps = state => ({
  modal: state.cardItem.deletePromptModal,
  plantId: state.cardItem.plantIdToDelete,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  deletePlant,
  onToggleDeleteModal
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DeleteFromModal);
